/* eslint-disable @typescript-eslint/explicit-member-accessibility */
/* eslint-disable complexity */
/* eslint-disable no-param-reassign */
/* eslint-disable no-else-return*/
import ShapeBaseModel from './base-modeles/shape-base-model';
import * as mobx from 'mobx';
import { transaction } from '@src/slide/domain/slide-app';
import { ptToCanvas } from '@src/slide/infrastructure/module/independent/unit';
import { ShapeType } from '@src/slide/infrastructure/module/dependent/shape-info/graphic-type';
import set from 'lodash/set';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import {
    IShapeModel,
    ITextAdjust,
    ITextPaddingAdjust,
    ShapeSubType,
} from '@src/slide/domain/ui-model/element-modeles/Interface/shape-model.interface';
import { ITextEditor } from '@src/slide/domain/ui-model/element-modeles/property/text/interface/text-editor.interface';
import {
    IGraphicProperty,
} from '@src/slide/domain/ui-model/element-modeles/property/graphic-info/graphic-info.interface';
import { GraphicProperty } from './property/graphic-info';
import _has from 'lodash/has';
import get from 'lodash/get';
import { cloneDeep } from '@tencent/slide-sdk-model/src/utils/clone-deep';
import { FillConverter } from '@src/slide/domain/ui-model/converter/node-property/module-property/fill/fill-converter';
import { TextConverter } from '@src/slide/domain/ui-model/converter/node-property/module-property/text/text-converter';
import { IObservableDataModel, IShapeDataModel, DataModelChange } from '@tencent/slide-sdk-model';
import AdjustTableCellBg from './property/fill/adjust-table-cell-bg';
import { IImageFillEffect } from './property/fill/image-fill/effect/image-fill-effect.interface';
import { ImageFillEffect } from './property/fill/image-fill/effect/image-fill-effect';
import { IImageFillSize } from './property/fill/image-fill/size/image-fill-size.interface';
import ImageFillSize from './property/fill/image-fill/size/image-fill-size';
import { IImageCrop } from './property/image-operation/interface/image-crop.interface';
import { ImageFillCrop } from './property/fill/image-fill/crop/image-fill-crop';
import { FillType } from './property/fill/fill.interface';
import ChangesetEngineV3 from '@src/slide/domain/ui-model/changesetManager/changeset-engine-v3';
import { IBaseModel } from '@src/slide/domain/ui-model/element-modeles/Interface/base/base-model.interface';
import ModelConverterBridge from '@src/slide/domain/ui-model/element-modeles/convert/model-converter-bridge';
import i18n from '@i18next/i18n';
import TextAdjustManager from '@src/slide/domain/ui-model/element-modeles/property/text/text-adjust';

const DEFAULT_VALUE = 0;
const DEFAULT_SHAPE_WIDTH = 14;
const DEFAULT_SHAPE_HEIGHT = 35;

// eslint-disable-next-line no-unused-vars
export function judgeParagraphListIsEmpty(paragraphList) {
    const p = mobx.toJS(paragraphList);
    if (!p) return true;
    if (!p.length) return true;
    if (p.length === 1) {
        if (!(p[0].textRuns?.length)) return true;
        if (p[0].textRuns.length === 1 && (!p[0].textRuns[0].text || p[0].textRuns[0].text === '' || p[0].textRuns[0].text === '\uFEFF')) return true;
    }

    return false;
}

const SHAPELIST = ['itemSymbol_circle',
    'itemSymbol_square',
    'itemSymbol_rhombus', 'itemSymbol_star',
    'itemSymbol_check',
    'itemSymbol_arrow',
    'itemSymbol_small_circle',
];

const NUMLIST  = ['itemSymbol_1',
    'itemSymbol_2',
    'itemSymbol_3',
    'itemSymbol_4',
    'itemSymbol_5',
    'itemSymbol_6',
    'itemSymbol_7',
    'itemSymbol_8'];

class ShapeModel extends ShapeBaseModel implements IShapeModel {
    // eslint-disable-next-line complexity
    static didConvertDataSdkToUi(sdkData, uiData, rawSdk, changesetInfo) {
        super.didConvertDataSdkToUi(sdkData, uiData, rawSdk);
        FillConverter.applyGrpFill(uiData);
        // 通过sdk原始数据与继承后的对比，将自有的属性打标，用来做数据提交时剔除继承属性
        TextConverter.sdkToUiSignRawTextProps(sdkData.getOwnedData?.().txBody, uiData);

        if (uiData?.inTable) {
            new AdjustTableCellBg().adjustCellBg(uiData, changesetInfo);
        }
        uiData.hasSlideNum = uiData?.hasSlideNumber?.();
        ShapeModel.collectUsingFonts(uiData);
    }

    /**
     * 收集使用中字体属性
     * @param {*} uiData
     */
    static collectUsingFonts(uiData: IShapeModel) {
        const fontManager = uiData?.getFontManager();
        if (!fontManager) {
            return;
        }
        fontManager.collectUsingFontsForShapeModel(uiData);
    }

    // 全量变化，而且uiData有几个值是必要的，所以开始的时候直接给uiData.props.style赋值
    static async convertDataSdkToUi(sdkData, uiData, rawData, option?) {
        super.convertDataSdkToUi(sdkData, uiData, rawData, option);

        const convertPromises: Array<Promise<any> | IBaseModel> = [];
        const convertShapeTask = ModelConverterBridge.convertSdkToUi({
            type: UIModelType.SHAPE,
            sdkData,
            uiData,
        });
        convertPromises.push(convertShapeTask);

        if (uiData.parent?.asyncConvertChildren) {
            await Promise.all(convertPromises);
        }
    }

    // TODO 不应该默认加一堆
    // eslint-disable-next-line complexity
    static convertDataUiToSdk(uiData, sdkData, rawUiData) {
        ModelConverterBridge.convertUiToSdk({ type: UIModelType.SHAPE, uiData, sdkData, rawUiData });
    }

    @mobx.observable selectionStyles = {};
    @mobx.observable isEditing = false;
    @mobx.observable operatingGraphicInfo = null;
    @mobx.observable isAttachmentShown = false;
    @mobx.observable hasSlideNum = false;
    @mobx.observable imageFillChange = DEFAULT_VALUE;

    tableModelRef = null;

    public inTable: boolean;
    public paragraphList;
    public textBodyStyle;
    public undoRedo: boolean;
    private editorComponent: ITextEditor | null;
    private updateState;
    private graphicProperty: GraphicProperty;
    private imageCropInstance: ImageFillCrop;
    private imageFillEffectInstance: IImageFillEffect;
    private imageFillSizeInstance: IImageFillSize;

    constructor() {
        super();
        this.editorComponent = null;
        this.props = {
            style: {
                left: 0,
                top: 0,
                width: ptToCanvas(DEFAULT_SHAPE_WIDTH),
                height: ptToCanvas(DEFAULT_SHAPE_HEIGHT),
                controlValues: [],
            },
            subType: 0, // 为1 表示是文本框
        };
        this.inTable = false;
        this.paragraphList = [];  // 通过paragraphChange来触发更新
        this.textBodyStyle = {};
        this.updateState = {
            editorShouldUpdate: false,
            backgroundShouldUpdate: false,
            borderShouldUpdate: false,
        };
    }

    public setEditorComponent(editorComponent: ITextEditor | null): void {
        this.editorComponent = editorComponent;
    }

    public get editorInstance(): ITextEditor | null {
        return this.editorComponent;
    }

    public getUpdateState() {
        return cloneDeep(this.updateState);
    }

    public setUpdateState(updateState) {
        this.updateState = Object.assign(this.updateState, updateState);
    }

    public get selectable(): boolean {
        const { attachment } = this.props;
        if (attachment && !attachment.objKey) {  // 如果是上传中状态，但是又没在上传队列里，就让其无法选中。
            const attachmentManager = this.getAttachmentManager();
            return (
                attachmentManager?.isUploadingAttachment(this.props.attachment.id)
                // @ts-ignore
                || attachmentManager?.isUploadError(this.id)
            ) ?? false;
        }
        return super.selectable;
    }

    public initParagraphList = () => {
        this.paragraphList = [{
            paragraphCharacter: {},
            paragraphProps: {},
            textRuns: [{
                styles: {
                    lang: 'ea',
                    fonts: { latin: i18n.t('默认字体'), ea: i18n.t('默认字体') },
                },
                text: '',
            }],
        }];
    };

    public updateParagraphListForUI(paragraphList) {
        this.paragraphList = paragraphList;
    }

    public updateTextAdjust(textAdjust: Partial<ITextAdjust>): void {
        const { autoFitType, autoBreakType } = textAdjust;
        const updateTextBodyStyle = {};
        if (autoFitType) {
            set(updateTextBodyStyle, 'autoFitType', autoFitType);
        }
        if (autoBreakType) {
            set(updateTextBodyStyle, 'bodyStyle.whiteSpace', autoBreakType);
        }
        transaction(() => {
            // 更新数据
            this.updateTextBodyStyle(updateTextBodyStyle);
        });
    }

    public updateShowFlatText(isFlatText: boolean): void {
        const updateTextBodyStyle = {
            bodyStyle: {
                isFlatText,
            },
        };
        transaction(() => {
            this.updateTextBodyStyle(updateTextBodyStyle);
        });
    }

    /**
     * 内边距设置修改，调整文本框/形状内边距
     * @param updateStyle 边距参数
     */
    // eslint-disable-next-line complexity
    public updatePaddingAdjust(updateStyle: Partial<ITextPaddingAdjust>): void {
        const { autoFitType, autoBreakType, paddingLeft, paddingRight, paddingTop, paddingBottom } = updateStyle;
        const updateTextBodyStyle = {};
        const padding: any = {};
        if (paddingLeft !== undefined && !isNaN(paddingLeft)) {
            padding.paddingLeft = paddingLeft;
        }
        if (paddingRight !== undefined && !isNaN(paddingRight)) {
            padding.paddingRight = paddingRight;
        }
        if (paddingTop !== undefined && !isNaN(paddingTop)) {
            padding.paddingTop = paddingTop;
        }
        if (paddingBottom !== undefined && !isNaN(paddingBottom)) {
            padding.paddingBottom = paddingBottom;
        }

        // 调整边距后，需要重新计算容器形状 (为防止修改后需要撤销两次，所以放到一起变更)
        if (autoFitType) {
            set(updateTextBodyStyle, 'autoFitType', autoFitType);
        }
        if (autoBreakType) {
            set(updateTextBodyStyle, 'bodyStyle.whiteSpace', autoBreakType);
        }

        // 更新textBodyStyle， 用于重新计算容器形状
        Object.keys(padding).forEach((key) => {
            const value = padding[key];
            set(updateTextBodyStyle, `bodyStyle.${key}`, value);
        });

        transaction(() => {
            // 更新数据
            this.updateTextBodyStyle(updateTextBodyStyle);
        });
    }

    /**
     * 是文本框或者占位符
     * @returns {*|boolean}
     */
    public get isTextOrPlaceholder(): boolean {
        // props.subType为1表示是文本框
        return this.isText || this.isPlaceholder;
    }

    /**
     * 是文本框
     * @returns {*|boolean}
     */
    public get isText(): boolean {
        // props.subType为1表示是文本框
        return this.props?.subType === ShapeSubType.TEXT_ELEMENT;
    }

    /**
     * 是否是公式
     * @returns {*|boolean}
     */
    public get isTextMath(): boolean {
        return !!(this.sdkData as unknown as IShapeDataModel)?.props?.nvPr.isEquationShape;
    }

    public changesSaved(): boolean {
        if (this.editorInstance?.changeFlag) {
            return false;
        }
        return true;
    }

    public isAttachment(): boolean {
        return !!this.props?.attachment;
    }

    public isAttachmentUploaded(): boolean {
        const attachment = get(this, 'props.attachment');
        return !!attachment?.objKey;
    }

    /**
     * 图形信息接口
     */
    public getGraphic(): IGraphicProperty {
        if (!this.graphicProperty) {
            this.graphicProperty = new GraphicProperty(this);
        }
        return this.graphicProperty;
    }

    /**
     * 存在幻灯片编号
     */
    public hasSlideNumber(): boolean {
        let existence = false;
        const { paragraphList } = this;
        paragraphList.forEach((paragraphs) => {
            paragraphs?.textRuns?.forEach((textRun) => {
                if (_has(textRun, 'fieldType') && textRun.fieldType === 'slidenum') {
                    existence = true;
                }
            });
        });
        return existence;
    }
    /**
     * 是否是文本形式的附件
     */
    public isTextAttachment(): boolean {
        if (this.isAttachment() && this.isText) {
            return true;
        }
        return false;
    }

    /**
     * 是否支持设置箭头样式
     */
    public canSetArrowStyle(): boolean {
        if (!this.pathParser) {
            return false;
        }
        const pathList = this.pathParser.svgPathInRect();
        // 多段path时，无需考虑首尾重合的情况，只需判断是否有闭合的指令即可
        if (pathList.length > 1) {
            return pathList.some(path => path.svgPath.indexOf('Z') === -1 && path.svgPath.indexOf('z') === -1);
        }
        return this.getGraphic().isPathOpened(pathList[0].svgPath);
    }

    public getImageCrop(): IImageCrop {
        if (!this.imageCropInstance) {
            this.imageCropInstance = new ImageFillCrop(this);
        }
        return this.imageCropInstance;
    }

    public getImageFillEffect(): IImageFillEffect | undefined  {
        if (this.getBackgroundFill().getFillType() !== FillType.ImageFill) return;
        if (!this.imageFillEffectInstance) {
            this.imageFillEffectInstance = new ImageFillEffect(this);
        }
        return this.imageFillEffectInstance;
    }

    public getImageFillSize(): IImageFillSize  {
        if (!this.imageFillSizeInstance) {
            this.imageFillSizeInstance = new ImageFillSize(this);
        }
        return this.imageFillSizeInstance;
    }

    public getTempCopiedModel(emptyCopiedUIModel: IShapeModel): IShapeModel {
        emptyCopiedUIModel.sdkData = this.sdkData;
        emptyCopiedUIModel.parent = this.slideRef;
        emptyCopiedUIModel.asyncConvertChildren = false;
        // @ts-ignore
        emptyCopiedUIModel.doConvertSdkDataModelToUiData(this.sdkData).catch();
        emptyCopiedUIModel.isPlaceholder = false;
        if (this.placeHolder) {
            emptyCopiedUIModel.placeHolder = undefined;
        }
        return emptyCopiedUIModel;
    }

    // 修改非文字属性时，触发下文字保存，否则更新后形状宽高可能不对
    public updateAndRemoveProps(updateProps, removeProps?) {
        this.triggerEditorSave();
        return super.updateAndRemoveProps(updateProps, removeProps);
    }

    // 修改非文字属性时，触发下文字保存，否则更新后形状宽高可能不对
    public updateBackgroundToImage(updateProps, removeProps?) {
        this.triggerEditorSave();
        return super.updateBackgroundToImage(updateProps, removeProps);
    }

    // 修改非文字属性时，触发下文字保存，否则更新后形状宽高可能不对
    public updateProps(props: any): void {
        this.triggerEditorSave();
        return super.updateProps(props);
    }

    /**
     * 获取文字内容
     */
    public getTextContent(): string {
        const contentArr: string[] = [];
        const p = this.sdkData?.props.txBody?.p;
        p?.forEach((paragraph) => {
            paragraph?.egTextRun?.forEach((textRun) => {
                contentArr.push(this.getRunText(textRun));
            });
        });

        return contentArr.join(' ');
    }

    getRunText = (textRun) => {
        const { t } = textRun.r || {};
        let resultText = t;
        if (!resultText) {
            resultText = '';
            if (textRun.br) {
                resultText = '\n';
            }
        }
        return resultText;
    };

    protected async sdkOnDidChangeV3(
        sdkData: IObservableDataModel,
        change?: DataModelChange,
    ): Promise<void> {
        if (ChangesetEngineV3.hasChangeAtPath(change || null, 'txBody')) {
            // 标记文本发生变化，渲染层靠此标识来更新editor
            this.updateState.editorShouldUpdate = true;
        } else {
            this.updateState.editorShouldUpdate = false;
        }
        if (this.parent?.type === UIModelType.GROUP) {
            // 如果当前 shape 是在组合内，数据更新完成之后清除下 textAdjust 中的缓存数据
            TextAdjustManager.getInstance().removeShapeToGroupInfoMap(this);
        }
        super.sdkOnDidChangeV3(sdkData, change);
    }

    /**
     * 触发文字保存
     */
    private triggerEditorSave() {
        try {
            if (this.editorInstance?.isEditing) {
                this.editorInstance.triggerSave();
            }
        } catch (error) {
            window.log.error(`[editorInstance.triggerSave-error]${error}`);
        }
    }
}


export default ShapeModel;

export const testObj = {
    SHAPELIST,
    NUMLIST,
};
